module.exports = __webpack_public_path__ + "static/media/bg_white_right.cf9d4293.png";